// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General video container */
.video-container {
  margin: 5px auto;
  padding: 10px;
  background-color: rgb(248, 247, 247);
  border: 2px solid rgb(236, 171, 9);
  box-shadow: 20px 14px 15px rgba(218, 226, 5, 0.2);
min-width: 100%;
  height: auto;
}

video {
  width: 100%;
  height: auto; 
  display: block;

}

.quiz-container {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

/* For small devices (phones) */
@media (max-width: 576px) {
  .video-container {
    max-width: 100%; /* Full width for phones */
  }
}

/* For medium devices (tablets) */
@media (min-width: 577px) and (max-width: 768px) {
  .video-container {
    max-width: 90%; /* 90% width for smaller tablets */
  }
}

/* Galaxy Tab and iPads in portrait mode (768px width) */
@media (min-width: 769px) and (max-width: 1024px) {
  .video-container {
    max-width: 85%; /* Adjust width for iPads and Galaxy Tab in portrait mode */
  }
}

/* iPad Pro 11" in portrait mode */
@media (min-width: 834px) and (max-width: 834px) {
  .video-container {
    max-width: 85%; /* Adjust width specifically for iPad Pro 11" */
  }
}

/* iPad Mini and iPad Air in landscape mode */
@media (min-width: 810px) and (max-width: 1080px) {
  .video-container {
    max-width: 80%; /* Adjust width for iPad Mini, Air in landscape */
  }
}

/* For larger devices like laptops */
@media (min-width: 1025px) and (max-width: 1200px) {
  .video-container {
    max-width: 80%; /* 80% width for laptops */
  }
}


@media (min-width: 1201px) {
  .video-container {
    max-width: 80%;
  }
}



.accordion-container {
  max-width: 900px; /* Maximum width for larger screens */
   width: 100%; /* Responsive width for smaller screens */
   margin: 0 auto; /* Center the Accordion */
   padding: 10px;
 }

 @media (max-width: 768px) {
   .accordion-container {
     max-width: 100%; /* Full width on smaller screens */
     padding: 5px;
   }
 }









.custom-question-accordion{
  width:100%;
  max-width: 1000px;
}

.accordion-button {
  background-color: #f8f9fa; /* Default background color */
  color: #000; /* Default text color */
  border: none; /* Optional: remove borders */
}


.accordion-button:hover {
  background-color: #ebeae6; /* Color when hovering over the header */
  color: #0f0d0d; /* Text color when hovering */
  font-weight:600;
}

.accordion-button:focus {
  box-shadow: none; /* Remove focus outline */
}

.accordion-button:not(.collapsed) {
  background-color: #f3f2ed; /* Color when accordion is open */
  color: #191717; /* Text color when open */
}
/* Default option style */
.option-item {
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  background-color: #fffbdf;
}

/* Highlight the selected option */
.selected-option {
  background-color:#ede28f; /* Custom color for selected option */
  color: #0c0b0b;
}.two h1 {
  text-transform: capitalize;
}
.two h1:before {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 2px;
  content: "";
  background-color: #c50000;
}

.two h1 span {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 4px;
  line-height: 3em;
  padding-left: 0.25em;
  color: rgba(0, 0, 0, 0.4);
  padding-bottom: 10px;
}
.alt-two h1 {
  text-align:center;
}
.alt-two h1:before {
  left:50%; margin-left:-30px;
}






/* Customize radio button */
.option-item input[type="radio"] {
visibility: hidden;
}

.option-item input[type="radio"] + label {
position: relative;
padding-left: 25px;
cursor: pointer;
font-size: 16px;
color: #000;
}

.option-item input[type="radio"] + label:before {
content: '';
position: absolute;
left: 0;
top: 2px;
width: 18px;
height: 18px;
border: 2px solid #ffc107; /* Set your warning color here */
border-radius: 50%;
background-color: transparent;
}

.option-item input[type="radio"]:checked + label:before {
background-color: #ffc107; /* Background color for selected radio */
border-color: #ffc107;
}

.option-item input[type="radio"]:checked + label:after {
content: '';
position: absolute;
left: 5px;
top: 7px;
width: 8px;
height: 8px;
background-color: white; /* Inner circle color */
border-radius: 50%;
}


/* modal */



/* Custom hover style for the close button */
.custom-close-btn:hover {
color: white;
background-color: red;
border-radius: 50%;
transition: background-color 0.3s ease;
}


.video-flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* Styles for watched-time box */
.watched-time {
  width: 100%;
  max-width: 300px;
  text-align: center;
  height: 40px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  padding: 5px;
  border: 1px solid orange;
  border-radius: 5px;
  font-size: 16px; /* Default font size */
}

/* Styles for download button container */
.downloadPage {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid orange;
  height: 40px;
  width: 100%;
  max-width: 200px;
  border-radius: 5px;
  cursor: pointer;
  gap: 5px;
}

/* Styles for the button image */
.watched-timeButton {
  height: 100%;
  width: 45px; /* Default size */
}

/* Styles for the download text */
.watched-timeTag {
  font-weight: bold;
  margin-top:20px;
}

/* Larger screen adjustments */
@media (min-width: 768px) {
  .video-flex-container {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
  }
  .watched-timeTag {
    font-weight: bold;
    margin-top:20px;
  }
  .video-heading-container{
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    height:10vh; /* Full viewport height */
    width: 100%; /* Full width */
    box-sizing: border-box; /* Include padding and border in width/height */
    background-color: #f9f9f9; /* Optional background color */
  }
}

/* Mobile view adjustments */
@media (max-width: 480px) {

  .video-flex-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 70px;
  }
  .watched-timeButton {
    width: 30px; /* Reduced image width for mobile */
    height:30px; /* Reduced image height for mobile */
  }

  .watched-time {
    width: 40%;
    max-width: 300px;
    text-align: center;
    height: 40px;
    color: rgb(0, 0, 0);
    font-weight: bold;
    padding: 5px;
    border: 1px solid orange;
    border-radius: 5px;
    font-size: 10px; /* Default font size */
  }
  
  /* Styles for download button container */
  .downloadPage {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid orange;
    height: 30px;
    width: 40%;
    max-width: 200px;
    border-radius: 5px;
    cursor: pointer;
    gap: 5px;
  }
  .watched-timeTag {
    font-weight: bold;
    font-size: 10px;
margin-top:20px;

  }
  .video-heading-container{
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    height:10vh; /* Full viewport height */
    width: 100%; /* Full width */
    box-sizing: border-box; /* Include padding and border in width/height */
    background-color: #f9f9f9; /* Optional background color */
  }
}

.video-heading-container{
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  height:30vh; /* Full viewport height */
  width: 100%; /* Full width */
  box-sizing: border-box; /* Include padding and border in width/height */
  background-color: #f9f9f9; /* Optional background color */
}

.video-heading-name {
  font-size: 1.5em; /* Responsive font size */
  font-weight: bold;
  font-family: Arial, sans-serif; /* Change font if needed */
  color: #333; /* Text color */
  text-align: center; /* Ensure text alignment */
  margin-top: 70px;
}
 `, "",{"version":3,"sources":["webpack://./src/Components/video/Video.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,iDAAiD;AACnD,eAAe;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;;AAEhB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE;IACE,eAAe,EAAE,0BAA0B;EAC7C;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,cAAc,EAAE,kCAAkC;EACpD;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,cAAc,EAAE,2DAA2D;EAC7E;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,cAAc,EAAE,+CAA+C;EACjE;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,cAAc,EAAE,iDAAiD;EACnE;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc,EAAE,0BAA0B;EAC5C;AACF;;;AAGA;EACE;IACE,cAAc;EAChB;AACF;;;;AAIA;EACE,gBAAgB,EAAE,qCAAqC;GACtD,WAAW,EAAE,yCAAyC;GACtD,cAAc,EAAE,yBAAyB;GACzC,aAAa;CACf;;CAEA;GACE;KACE,eAAe,EAAE,kCAAkC;KACnD,YAAY;GACd;CACF;;;;;;;;;;AAUD;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,WAAW,EAAE,uBAAuB;EACpC,YAAY,EAAE,6BAA6B;AAC7C;;;AAGA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc,EAAE,6BAA6B;EAC7C,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,cAAc,EAAE,yBAAyB;AAC3C;AACA,yBAAyB;AACzB;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,wBAAwB,EAAE,qCAAqC;EAC/D,cAAc;AAChB,CAAC;EACC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,QAAQ,EAAE,iBAAiB;AAC7B;;;;;;;AAOA,2BAA2B;AAC3B;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB,kBAAkB;AAClB,eAAe;AACf,eAAe;AACf,WAAW;AACX;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,OAAO;AACP,QAAQ;AACR,WAAW;AACX,YAAY;AACZ,yBAAyB,EAAE,gCAAgC;AAC3D,kBAAkB;AAClB,6BAA6B;AAC7B;;AAEA;AACA,yBAAyB,EAAE,wCAAwC;AACnE,qBAAqB;AACrB;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,SAAS;AACT,QAAQ;AACR,UAAU;AACV,WAAW;AACX,uBAAuB,EAAE,uBAAuB;AAChD,kBAAkB;AAClB;;;AAGA,UAAU;;;;AAIV,4CAA4C;AAC5C;AACA,YAAY;AACZ,qBAAqB;AACrB,kBAAkB;AAClB,sCAAsC;AACtC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe,EAAE,sBAAsB;AACzC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,WAAW,EAAE,iBAAiB;AAChC;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,WAAW,EAAE,yBAAyB;IACtC,WAAW,EAAE,eAAe;IAC5B,sBAAsB,EAAE,+CAA+C;IACvE,yBAAyB,EAAE,8BAA8B;EAC3D;AACF;;AAEA,4BAA4B;AAC5B;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,WAAW,EAAE,mCAAmC;IAChD,WAAW,EAAE,oCAAoC;EACnD;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe,EAAE,sBAAsB;EACzC;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,eAAe;AACnB,eAAe;;EAEb;EACA;IACE,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,WAAW,EAAE,yBAAyB;IACtC,WAAW,EAAE,eAAe;IAC5B,sBAAsB,EAAE,+CAA+C;IACvE,yBAAyB,EAAE,8BAA8B;EAC3D;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,WAAW,EAAE,yBAAyB;EACtC,WAAW,EAAE,eAAe;EAC5B,sBAAsB,EAAE,+CAA+C;EACvE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,iBAAiB;EACjB,8BAA8B,EAAE,0BAA0B;EAC1D,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB;AAClB","sourcesContent":["/* General video container */\r\n.video-container {\r\n  margin: 5px auto;\r\n  padding: 10px;\r\n  background-color: rgb(248, 247, 247);\r\n  border: 2px solid rgb(236, 171, 9);\r\n  box-shadow: 20px 14px 15px rgba(218, 226, 5, 0.2);\r\nmin-width: 100%;\r\n  height: auto;\r\n}\r\n\r\nvideo {\r\n  width: 100%;\r\n  height: auto; \r\n  display: block;\r\n\r\n}\r\n\r\n.quiz-container {\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* For small devices (phones) */\r\n@media (max-width: 576px) {\r\n  .video-container {\r\n    max-width: 100%; /* Full width for phones */\r\n  }\r\n}\r\n\r\n/* For medium devices (tablets) */\r\n@media (min-width: 577px) and (max-width: 768px) {\r\n  .video-container {\r\n    max-width: 90%; /* 90% width for smaller tablets */\r\n  }\r\n}\r\n\r\n/* Galaxy Tab and iPads in portrait mode (768px width) */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .video-container {\r\n    max-width: 85%; /* Adjust width for iPads and Galaxy Tab in portrait mode */\r\n  }\r\n}\r\n\r\n/* iPad Pro 11\" in portrait mode */\r\n@media (min-width: 834px) and (max-width: 834px) {\r\n  .video-container {\r\n    max-width: 85%; /* Adjust width specifically for iPad Pro 11\" */\r\n  }\r\n}\r\n\r\n/* iPad Mini and iPad Air in landscape mode */\r\n@media (min-width: 810px) and (max-width: 1080px) {\r\n  .video-container {\r\n    max-width: 80%; /* Adjust width for iPad Mini, Air in landscape */\r\n  }\r\n}\r\n\r\n/* For larger devices like laptops */\r\n@media (min-width: 1025px) and (max-width: 1200px) {\r\n  .video-container {\r\n    max-width: 80%; /* 80% width for laptops */\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 1201px) {\r\n  .video-container {\r\n    max-width: 80%;\r\n  }\r\n}\r\n\r\n\r\n\r\n.accordion-container {\r\n  max-width: 900px; /* Maximum width for larger screens */\r\n   width: 100%; /* Responsive width for smaller screens */\r\n   margin: 0 auto; /* Center the Accordion */\r\n   padding: 10px;\r\n }\r\n\r\n @media (max-width: 768px) {\r\n   .accordion-container {\r\n     max-width: 100%; /* Full width on smaller screens */\r\n     padding: 5px;\r\n   }\r\n }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.custom-question-accordion{\r\n  width:100%;\r\n  max-width: 1000px;\r\n}\r\n\r\n.accordion-button {\r\n  background-color: #f8f9fa; /* Default background color */\r\n  color: #000; /* Default text color */\r\n  border: none; /* Optional: remove borders */\r\n}\r\n\r\n\r\n.accordion-button:hover {\r\n  background-color: #ebeae6; /* Color when hovering over the header */\r\n  color: #0f0d0d; /* Text color when hovering */\r\n  font-weight:600;\r\n}\r\n\r\n.accordion-button:focus {\r\n  box-shadow: none; /* Remove focus outline */\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  background-color: #f3f2ed; /* Color when accordion is open */\r\n  color: #191717; /* Text color when open */\r\n}\r\n/* Default option style */\r\n.option-item {\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n  background-color: #fffbdf;\r\n}\r\n\r\n/* Highlight the selected option */\r\n.selected-option {\r\n  background-color:#ede28f; /* Custom color for selected option */\r\n  color: #0c0b0b;\r\n}.two h1 {\r\n  text-transform: capitalize;\r\n}\r\n.two h1:before {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 60px;\r\n  height: 2px;\r\n  content: \"\";\r\n  background-color: #c50000;\r\n}\r\n\r\n.two h1 span {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  letter-spacing: 4px;\r\n  line-height: 3em;\r\n  padding-left: 0.25em;\r\n  color: rgba(0, 0, 0, 0.4);\r\n  padding-bottom: 10px;\r\n}\r\n.alt-two h1 {\r\n  text-align:center;\r\n}\r\n.alt-two h1:before {\r\n  left:50%; margin-left:-30px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Customize radio button */\r\n.option-item input[type=\"radio\"] {\r\nvisibility: hidden;\r\n}\r\n\r\n.option-item input[type=\"radio\"] + label {\r\nposition: relative;\r\npadding-left: 25px;\r\ncursor: pointer;\r\nfont-size: 16px;\r\ncolor: #000;\r\n}\r\n\r\n.option-item input[type=\"radio\"] + label:before {\r\ncontent: '';\r\nposition: absolute;\r\nleft: 0;\r\ntop: 2px;\r\nwidth: 18px;\r\nheight: 18px;\r\nborder: 2px solid #ffc107; /* Set your warning color here */\r\nborder-radius: 50%;\r\nbackground-color: transparent;\r\n}\r\n\r\n.option-item input[type=\"radio\"]:checked + label:before {\r\nbackground-color: #ffc107; /* Background color for selected radio */\r\nborder-color: #ffc107;\r\n}\r\n\r\n.option-item input[type=\"radio\"]:checked + label:after {\r\ncontent: '';\r\nposition: absolute;\r\nleft: 5px;\r\ntop: 7px;\r\nwidth: 8px;\r\nheight: 8px;\r\nbackground-color: white; /* Inner circle color */\r\nborder-radius: 50%;\r\n}\r\n\r\n\r\n/* modal */\r\n\r\n\r\n\r\n/* Custom hover style for the close button */\r\n.custom-close-btn:hover {\r\ncolor: white;\r\nbackground-color: red;\r\nborder-radius: 50%;\r\ntransition: background-color 0.3s ease;\r\n}\r\n\r\n\r\n.video-flex-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n/* Styles for watched-time box */\r\n.watched-time {\r\n  width: 100%;\r\n  max-width: 300px;\r\n  text-align: center;\r\n  height: 40px;\r\n  color: rgb(0, 0, 0);\r\n  font-weight: bold;\r\n  padding: 5px;\r\n  border: 1px solid orange;\r\n  border-radius: 5px;\r\n  font-size: 16px; /* Default font size */\r\n}\r\n\r\n/* Styles for download button container */\r\n.downloadPage {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid orange;\r\n  height: 40px;\r\n  width: 100%;\r\n  max-width: 200px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  gap: 5px;\r\n}\r\n\r\n/* Styles for the button image */\r\n.watched-timeButton {\r\n  height: 100%;\r\n  width: 45px; /* Default size */\r\n}\r\n\r\n/* Styles for the download text */\r\n.watched-timeTag {\r\n  font-weight: bold;\r\n  margin-top:20px;\r\n}\r\n\r\n/* Larger screen adjustments */\r\n@media (min-width: 768px) {\r\n  .video-flex-container {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    padding: 0 10px;\r\n  }\r\n  .watched-timeTag {\r\n    font-weight: bold;\r\n    margin-top:20px;\r\n  }\r\n  .video-heading-container{\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    height:10vh; /* Full viewport height */\r\n    width: 100%; /* Full width */\r\n    box-sizing: border-box; /* Include padding and border in width/height */\r\n    background-color: #f9f9f9; /* Optional background color */\r\n  }\r\n}\r\n\r\n/* Mobile view adjustments */\r\n@media (max-width: 480px) {\r\n\r\n  .video-flex-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 70px;\r\n  }\r\n  .watched-timeButton {\r\n    width: 30px; /* Reduced image width for mobile */\r\n    height:30px; /* Reduced image height for mobile */\r\n  }\r\n\r\n  .watched-time {\r\n    width: 40%;\r\n    max-width: 300px;\r\n    text-align: center;\r\n    height: 40px;\r\n    color: rgb(0, 0, 0);\r\n    font-weight: bold;\r\n    padding: 5px;\r\n    border: 1px solid orange;\r\n    border-radius: 5px;\r\n    font-size: 10px; /* Default font size */\r\n  }\r\n  \r\n  /* Styles for download button container */\r\n  .downloadPage {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 1px solid orange;\r\n    height: 30px;\r\n    width: 40%;\r\n    max-width: 200px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    gap: 5px;\r\n  }\r\n  .watched-timeTag {\r\n    font-weight: bold;\r\n    font-size: 10px;\r\nmargin-top:20px;\r\n\r\n  }\r\n  .video-heading-container{\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    height:10vh; /* Full viewport height */\r\n    width: 100%; /* Full width */\r\n    box-sizing: border-box; /* Include padding and border in width/height */\r\n    background-color: #f9f9f9; /* Optional background color */\r\n  }\r\n}\r\n\r\n.video-heading-container{\r\n  display: flex;\r\n  justify-content: center; /* Center horizontally */\r\n  align-items: center; /* Center vertically */\r\n  height:30vh; /* Full viewport height */\r\n  width: 100%; /* Full width */\r\n  box-sizing: border-box; /* Include padding and border in width/height */\r\n  background-color: #f9f9f9; /* Optional background color */\r\n}\r\n\r\n.video-heading-name {\r\n  font-size: 1.5em; /* Responsive font size */\r\n  font-weight: bold;\r\n  font-family: Arial, sans-serif; /* Change font if needed */\r\n  color: #333; /* Text color */\r\n  text-align: center; /* Ensure text alignment */\r\n  margin-top: 70px;\r\n}\r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
